export default function StatsSection() {
  const stats = [
    { value: '3,000+', label: '海量漫画资源', desc: '韩漫国漫日漫全覆盖' },
    { value: '500万+', label: '月活跃用户', desc: '口碑相传持续增长' },
    { value: '50亿+', label: '累计阅读次数', desc: '每一话都值得品味' },
    { value: '99.9%', label: '服务可用率', desc: '阅读从不掉线' },
  ];

  return (
    <section className="py-10 md:py-14 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-sm font-medium text-background-50/90 mt-1">{stat.label}</div>
              <div className="text-xs text-background-50/60 mt-1">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}